import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../common/Table/table";
import { FaSearch } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  getAllStockSlice,
  getStockByIdSlice,
  createAddStockSlice,
  getLowStockSlice,
  updateStockSlice,
  deleteStockSlice,
  resetCreateStockMessage,
  resetUpdateStockMessage,
  resetDeleteStockMessage,
} from "../../../store/slices/stockInventorySlice";
import AddUpdateStock from "./addUpdateStock";
import { getSupplierSlice } from "../../../store/slices/supplierSlice";
import { getAllClinic } from "../../../store/slices/clinicSlice";
import { getMedicineTypeSlice } from "../../../store/slices/medicineTypeSlice";

import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ViewModal from "../../common/viewModal/globalViewModal";

const StockInventory = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const initialState = {
    id: "",
    name: "",
    clinicId: "",
    supplier: "",
    supplierName: "",
    batchNumber: "",
    hsnCode: "",
    medicineType: "",
    quantity: "",
    unit: "",
    mrp: "",
    lowStock: "",
    expiryDate: "",
  };
  const [stockFormData, setStockFormData] = useState(initialState);

  const [inputError, setInputError] = useState({
    text: false,
  });
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const navigate = useNavigate();
  const {
    stockInventory,
    stockInfo,
    createStockSuccessMessage,
    createStockErrorMessage,
    updateStockSuccessMessage,
    updateStockErrorMessage,
    deleteStockSuccessMessage,
    deleteStockErrorMessage,
    searchStockErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.stockInventory);

  const { supplier } = useSelector((state) => state.supplier);
  const { medicineTypes } = useSelector((state) => state.medicineType);

  const fetchStock = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAllStockSlice({
            clinicId,
            status: tableStatus,
            token,
            currentPage: page,
            limit: lim,
            search: search || undefined,
          }),
        );
      }
    },
    [clinicId, token, dispatch, tableStatus, searchValue, pageLimit],
  );

  useEffect(() => {
    fetchStock();
  }, [fetchStock, modalVisible, showGlobalViewModal]);
  const handlePageChange = (page) => {
    fetchStock(page, pageLimit, searchValue);
  };
  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchStock(1, newLimit, searchValue);
  };

  useEffect(() => {
    dispatch(
      getLowStockSlice({
        clinicId,
        token,
      }),
    );
  }, [dispatch, modalVisible, selectedAction, token, clinicId]);

  useEffect(() => {
    dispatch(getSupplierSlice({ clinicId, token }));
    dispatch(getMedicineTypeSlice({ token }));
    dispatch(getAllClinic({ clinicId, token }));
  }, [dispatch, clinicId, token]);

  useEffect(() => {
    if (createStockSuccessMessage) {
      showToastifySuccess(createStockSuccessMessage);
      dispatch(resetCreateStockMessage());
    }
    if (createStockErrorMessage) {
      showToastifyError(createStockErrorMessage);
      dispatch(resetCreateStockMessage());
    }
    if (updateStockSuccessMessage) {
      showToastifySuccess(updateStockSuccessMessage);
      dispatch(resetUpdateStockMessage());
    }
    if (updateStockErrorMessage) {
      showToastifyError(updateStockErrorMessage);
      dispatch(resetUpdateStockMessage());
    }
    if (deleteStockSuccessMessage) {
      showToastifySuccess(deleteStockSuccessMessage);
      dispatch(resetDeleteStockMessage());
    }
    if (deleteStockErrorMessage) {
      showToastifyError(deleteStockErrorMessage);
      dispatch(resetDeleteStockMessage());
    }
  }, [
    createStockSuccessMessage,
    createStockErrorMessage,
    updateStockSuccessMessage,
    updateStockErrorMessage,
    deleteStockSuccessMessage,
    deleteStockErrorMessage,
    searchStockErrorMessage,
    dispatch,
  ]);

  const handleUpdateStatus = async (status, item) => {
    try {
      const updateData = {
        id: item?.id || item?._id,
        name: item?.name,
        supplier: item?.supplier?._id || item?.supplier,
        batchNumber: item?.batchNumber,
        hsnCode: item?.hsnCode,
        medicineType: item?.medicineType?._id || item?.medicineType,
        quantity: item?.quantity,
        unit: item?.unit,
        mrp: item?.mrp,
        lowStock: item?.lowStock,
        expiryDate: item?.expiryDate,
        clinicId,
        token,
      };

      await dispatch(updateStockSlice(updateData));
      fetchStock(currentPage, pageLimit, searchValue);
    } catch (err) {
      console.error(err);
    }
  };

  const tableHead = [
    { title: "Name", key: "name" },
    { title: "Supplier", key: "supplierName" },
    { title: "Batch Number", key: "batchNumber" },
    { title: "HSN Code", key: "hsnCode" },
    { title: "Medicine Type", key: "medicineTypeName" },
    { title: "Quantity", key: "quantity" },
    { title: "Unit", key: "unit" },
    { title: "MRP", key: "mrp" },
    { title: "Low Stock", key: "lowStock" },
    { title: "Expiry Date", key: "expiryDate" },
  ];

  const handleShowGlobalViewModal = (item) => {
    dispatch(
      getStockByIdSlice({
        stockId: item?.id,
        clinicId,
        token,
      }),
    );
    setShowGlobalViewModal(true);
  };

  const title = [
    { title: "Name", key: "name" },
    { title: "Supplier", key: "supplier" },
    { title: "Batch Number", key: "batchNumber" },
    { title: "HSN Code", key: "hsnCode" },
    { title: "Medicine Type", key: "medicineType" },
    { title: "Quantity", key: "quantity" },
    { title: "Unit", key: "unit" },
    { title: "MRP", key: "mrp" },
    { title: "Low Stock", key: "lowStock" },
    { title: "Expiry Date", key: "expiryDate" },
  ];

  const handleAddModal = () => {
    setStockFormData(initialState);
    setSelectedAction("Create");
    setModalVisible(true);
  };

  const handleAddOrUpdatetock = async (e) => {
    e.preventDefault();
    const { text } = inputError;
    if (text) return;
    try {
      if (selectedAction === "Update") {
        await dispatch(
          updateStockSlice({
            ...stockFormData,
            clinicId,
            token,
          }),
        );
      } else {
        await dispatch(
          createAddStockSlice({
            ...stockFormData,
            clinicId,
            token,
          }),
        );
      }
      setStockFormData(initialState);
      setModalVisible(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleFormData = (e) => {
    setStockFormData({
      ...stockFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSetSupplierEdit = (selectedOption) => {
    setStockFormData({
      ...stockFormData,
      supplier: selectedOption?.value,
      supplierName: selectedOption?.label,
    });
  };

  const handleSetMedicineTypeEdit = (item) => {
    setStockFormData({
      ...stockFormData,
      medicineType: item.value,
      medicineTypeName: item.label,
    });
  };

  const handleUpdate = (item) => {
    setStockFormData({
      stockId: item?.id || "",
      name: item?.name || "",
      clinicId,
      supplier: item?.supplier || "",
      supplierName: item?.supplierName || "",
      batchNumber: item?.batchNumber || "",
      hsnCode: item?.hsnCode || "",
      medicineType: item?.medicineType || "",
      medicineTypeName: item?.medicineTypeName || "",
      quantity: item?.quantity || "",
      unit: item?.unit || "",
      mrp: item?.mrp || "",
      lowStock: item?.lowStock || "",
      expiryDate: item?.expiryDate?.split("T")[0] || "",
    });

    setSelectedAction("Update");
    setModalVisible(true);
  };

  const handleDelete = (data) => {
    setStockFormData({
      stockId: data.id,
    });
    setSelectedAction("Delete");
    setDeleteModal(true);
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        deleteStockSlice({
          ...stockFormData,
          clinicId,
          token,
        }),
      );
      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchStock(1, pageLimit, value);
    },
    [fetchStock, pageLimit],
  );

  const heading = () => {
    return (
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        <div className="me-4 d-none d-lg-block">
          <div
            className="btn btn-primary btn-rounded"
            onClick={() => handleAddModal()}
          >
            + Add
          </div>
        </div>

        <div className="me-4 d-none d-lg-block">
          <div
            className="btn btn-primary btn-rounded"
            onClick={() => navigate("/lowStock")}
            style={{ cursor: "pointer" }}
          >
            Low Stock
          </div>
        </div>

        <div className="input-group search-area ms-auto d-inline-flex me-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search here"
            value={searchValue}
            onChange={handleSearch}
          />
          <div className="input-group-append">
            <button type="button" className="input-group-text">
              <FaSearch className="flaticon-381-search-2" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {heading()}
      <Table
        tableHead={tableHead && tableHead}
        tableBody={
          stockInventory &&
          stockInventory?.map((item, index) => ({
            id: item?._id,
            name: item?.name,
            supplier: item?.supplier?._id,
            supplierName: item?.supplier?.name,
            batchNumber: item?.batchNumber,
            hsnCode: item?.hsnCode,
            medicineType: item?.medicineType?._id,
            medicineTypeName: item?.medicineType?.name,
            quantity: item?.quantity,
            unit: item?.unit,
            mrp: item?.mrp,
            lowStock: item?.lowStock,
            expiryDate: item?.expiryDate
              ? new Date(item.expiryDate).toISOString().split("T")[0]
              : "",
          }))
        }
        handleUpdateStatus={handleUpdateStatus}
        // handleAddBtn={true}
        handleSearchOption={true}
        // handleAddModal={handleAddModal}
        // handleSearch={handleSearch}
        handleEdit={handleUpdate}
        handleDelete={handleDelete}
        errorMessage={searchStockErrorMessage}
        searchValue={searchValue}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        addModal={handleAddModal}
        showPaymentStatusTab={false}
        hideStatusTab={false}
        // handleShare={false}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />

      {/* Add and Update Medicine Modal */}
      <AddUpdateStock
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        stockFormData={stockFormData}
        handleAddOrUpdatetock={handleAddOrUpdatetock}
        selectedAction={selectedAction}
        handleFormData={handleFormData}
        handleSetSupplierEdit={handleSetSupplierEdit}
        handleSetMedicineTypeEdit={handleSetMedicineTypeEdit}
        setInputError={setInputError}
        medicineTypes={medicineTypes}
        supplier={supplier}
        setStockFormData={setStockFormData}
      />
      {/* Add and Update Medicine Modal end */}

      {/* delete Modal */}
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete the Stock{" "}
            <strong className="text-dark">{stockFormData?.name}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={title && title}
        content={{
          name: stockInfo?.name,
          supplier: stockInfo?.supplier?.name,
          batchNumber: stockInfo?.batchNumber,
          hsnCode: stockInfo?.hsnCode,
          medicineType: stockInfo?.medicineType?.name,
          quantity: stockInfo?.quantity,
          unit: stockInfo?.unit,
          mrp: stockInfo?.mrp,
          lowStock: stockInfo?.lowStock,

          expiryDate: stockInfo.expiryDate
            ? new Date(stockInfo.expiryDate).toISOString().split("T")[0]
            : "",
        }}
      />
    </>
  );
};

export default StockInventory;
